document.getElementById("goBackLink")?.addEventListener("click", () => {
    history.back();
});